module.exports = __webpack_public_path__ + "img/1723689594907-kacang goreng.jpg.111936b7.webp";